import { h } from 'preact';
import UIElement from '../internal/UIElement/UIElement';
import BlikInput from '../../components/Blik/components/BlikInput';
import { Await } from '../internal/Await';
import config from './config';
import RedirectButton from '../../components/internal/RedirectButton';
import { TxVariants } from '../tx-variants';
import { AwaitConfiguration } from '../internal/Await/types';

interface BlikElementData {
    paymentMethod: {
        type: string;
        blikCode: string;
    };
}

class BlikElement extends UIElement<AwaitConfiguration> {
    public static readonly type = TxVariants.blik;

    formatData(): BlikElementData {
        const recurringPayment = !!this.props.storedPaymentMethodId;

        return {
            paymentMethod: {
                type: BlikElement.type,
                ...(!recurringPayment && { blikCode: this.state?.data?.blikCode }),
                ...(recurringPayment && { storedPaymentMethodId: this.props.storedPaymentMethodId })
            }
        };
    }

    get isValid(): boolean {
        if (this.props.storedPaymentMethodId) {
            return true;
        }

        return !!this.state.isValid;
    }

    get displayName() {
        if (this.props.storedPaymentMethodId && this.props.label) {
            return this.props.label;
        }
        return this.props.name;
    }

    get additionalInfo() {
        if (this.props.storedPaymentMethodId && this.props.label) {
            return this.props.name;
        }
        return null;
    }

    /**
     * NOTE: for future reference:
     *  this.props.onComplete (which is called from this.onComplete) equates to the merchant defined onAdditionalDetails callback
     *  (the initial /payments response defines an "await" action, actionTypes.ts translates this to "onComplete: props.onAdditionalDetails")
     */
    protected override componentToRender(): h.JSX.Element {
        if (this.props.paymentData) {
            return (
                <Await
                    clientKey={this.props.clientKey}
                    paymentData={this.props.paymentData}
                    onError={this.handleError}
                    onComplete={this.onComplete}
                    brandLogo={this.icon}
                    type={config.type}
                    messageText={this.props.i18n.get(config.messageTextId)}
                    awaitText={this.props.i18n.get(config.awaitTextId)}
                    showCountdownTimer={config.showCountdownTimer}
                    delay={config.STATUS_INTERVAL}
                    countdownTime={config.COUNTDOWN_MINUTES}
                    throttleTime={config.THROTTLE_TIME}
                    throttleInterval={config.THROTTLE_INTERVAL}
                    onActionHandled={this.onActionHandled}
                />
            );
        }

        return this.props.storedPaymentMethodId ? (
            <RedirectButton
                showPayButton={this.props.showPayButton}
                name={this.displayName}
                payButton={this.payButton}
                onSubmit={this.submit}
                ref={ref => {
                    this.componentRef = ref;
                }}
            />
        ) : (
            <BlikInput
                // @ts-ignore Ref is used by preact component
                ref={ref => {
                    this.componentRef = ref;
                }}
                {...this.props}
                onChange={this.setState}
                onSubmit={this.submit}
                payButton={this.payButton}
            />
        );
    }
}

export default BlikElement;
